/** Floating dismissible card that surfaces the active onboarding hint body. */
import { Box, Button, Paper, Typography } from '@mui/material';
import { useT } from '@/i18n/useT';
import { onboardingHintCardPositionSx } from '@/features/onboarding/utils/onboardingHintCardSx';

/**
 * @param {Object} props
 * @param {string} props.body
 * @param {string} [props.title]
 * @param {() => void} props.onDismiss
 * @param {string} [props.testId]
 * @param {import('@mui/material').SxProps} [props.positionSx]
 * @param {number} [props.dismissTabIndex]
 */
const OnboardingHintCard = ({
  body,
  title,
  onDismiss,
  testId,
  positionSx = onboardingHintCardPositionSx,
  dismissTabIndex,
}) => {
  const t = useT();

  return (
    <Paper
      variant="outlined"
      data-testid={testId}
      role="status"
      aria-live="polite"
      sx={positionSx}
    >
      {title ? (
        <Typography variant="subtitle2" sx={{ mb: 0.75 }}>
          {title}
        </Typography>
      ) : null}
      <Typography variant="body2" sx={{ mb: 1.5 }}>
        {body}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <Button
          variant="contained"
          size="small"
          onClick={onDismiss}
          tabIndex={dismissTabIndex}
        >
          {t('onboarding.hint.dismiss', 'Begrepen')}
        </Button>
      </Box>
    </Paper>
  );
};

export default OnboardingHintCard;
